import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export const useCanEditCourse = (courseId: string) => {
  const [canEdit, setCanEdit] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkPermissions = async () => {
      if (!courseId) {
        setLoading(false);
        return;
      }

      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) {
          setCanEdit(false);
          setLoading(false);
          return;
        }

        // Check if user is instructor of this course
        const { data: course } = await supabase
          .from("courses")
          .select("instructor_id")
          .eq("id", courseId)
          .single();

        if (course?.instructor_id === user.id) {
          setCanEdit(true);
          setLoading(false);
          return;
        }

        // Check if user has admin or super_admin role
        const { data: roles } = await supabase
          .from("user_roles")
          .select("role")
          .eq("user_id", user.id)
          .in("role", ["admin", "super_admin", "instructor"]);

        if (roles && roles.length > 0) {
          setCanEdit(true);
        }
      } catch (error) {
        console.error("Error checking edit permissions:", error);
      } finally {
        setLoading(false);
      }
    };

    checkPermissions();
  }, [courseId]);

  return { canEdit, loading };
};
